import { render, staticRenderFns } from "./PushService.vue?vue&type=template&id=0d8d1938&"
import script from "./PushService.vue?vue&type=script&lang=js&"
export * from "./PushService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports